var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRoles = function SvgRoles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.578 11.845a2.611 2.611 0 0 1 2.603 2.443l.006.165v1.97a2.611 2.611 0 0 1-2.444 2.603l-.165.005h-1.97a2.611 2.611 0 0 1-2.603-2.444L2 16.422v-1.969a2.611 2.611 0 0 1 2.444-2.603l.165-.005h1.969zm0 1.28H4.609a1.33 1.33 0 0 0-1.323 1.2l-.006.128v1.97c0 .69.527 1.257 1.2 1.322l.129.006h1.969a1.33 1.33 0 0 0 1.323-1.2l.006-.129v-1.968a1.33 1.33 0 0 0-1.33-1.33zm13.782 1.673a.64.64 0 0 1 .095 1.273l-.095.007h-7.876a.64.64 0 0 1-.094-1.273l.094-.007h7.876zM6.578 2A2.611 2.611 0 0 1 9.18 4.444l.006.165v1.969A2.611 2.611 0 0 1 6.743 9.18l-.165.006h-1.97a2.611 2.611 0 0 1-2.603-2.444L2 6.578v-1.97a2.611 2.611 0 0 1 2.444-2.603L4.609 2h1.969zm0 1.28H4.609a1.33 1.33 0 0 0-1.323 1.2l-.006.129v1.969c0 .69.527 1.257 1.2 1.323l.129.006h1.969A1.33 1.33 0 0 0 7.9 6.706l.006-.128V4.609a1.33 1.33 0 0 0-1.33-1.33zM20.36 4.953a.64.64 0 0 1 .1 1.272l-.1.008h-7.876a.64.64 0 0 1-.094-1.273l.094-.007h7.876z"
  })));
};

export default SvgRoles;